import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X, LayoutDashboard } from "lucide-react";

const DEFAULT_TAB = {
  path: "/dashboard",
  label: "Dashboard",
  icon: LayoutDashboard,
  closable: false,
};

export default function WorkspaceTabs({ tabs = [], pinnedTabs = [], onClose, onActivate }) {
  const location = useLocation();
  const navigate = useNavigate();

  const normalizedTabs = [
    DEFAULT_TAB,
    ...pinnedTabs.filter(
      (tab) =>
        tab &&
        typeof tab.path === "string" &&
        tab.path !== DEFAULT_TAB.path
    ),
    ...tabs.filter(
      (tab) =>
        tab &&
        typeof tab.path === "string" &&
        tab.path !== DEFAULT_TAB.path
    ),
  ];

  const uniqueTabs = normalizedTabs.filter(
    (tab, index, list) =>
      list.findIndex((item) => item.path === tab.path) === index
  );

  const activePath = location.pathname + location.search;

  return (
    <div
      data-workspace-tabs
      role="tablist"
      aria-label="Workspace"
      className="relative z-30 flex min-w-0 min-h-[36px] shrink-0 items-stretch gap-0 overflow-x-auto border-b border-[#8da6bd] bg-[#164875] px-1"
    >
      {uniqueTabs.map((tab) => {
        const active = tab.path === activePath ||
          (tab.path === location.pathname && !location.search);
        const Icon = tab.icon;

        return (
          <div
            key={tab.id || tab.path}
            role="presentation"
            className={`group flex shrink-0 items-center border-b-2 ${
              active
                ? "border-orange-500 bg-orange-50/70"
                : "border-transparent hover:bg-slate-50"
            }`}
          >
            <button
              type="button"
              role="tab"
              aria-selected={active}
              aria-current={active ? "page" : undefined}
              onClick={() => {
                onActivate?.(tab);
                navigate(tab.path);
              }}
              className="flex shrink-0 items-center gap-2 whitespace-nowrap px-3 py-2.5 text-xs font-medium"
              style={{
                backgroundColor: active ? "#ffffff" : "#164875",
                color: active ? "#123b63" : "#ffffff",
                borderBottom: active ? "2px solid #e83e8c" : "2px solid transparent",
                minHeight: "36px",
                opacity: 1,
                visibility: "visible",
              }}
            >
              {Icon && <Icon className="h-3.5 w-3.5 shrink-0" />}
              <span className="max-w-48 truncate">{tab.label}</span>
            </button>

            {tab.closable && typeof onClose === "function" && (
              <button
                type="button"
                aria-label={`Tutup tab ${tab.label}`}
                title={`Tutup tab ${tab.label}`}
                onClick={() => onClose(tab.id)}
                className="mr-1 rounded p-1 text-slate-400 hover:bg-slate-200 hover:text-slate-700"
              >
                <X className="h-3 w-3" />
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
